module.exports = __webpack_public_path__ + "img/multfilmy_0.ae2d758b.png";